import React, { PropsWithChildren, ReactNode } from 'react'
import classes from './Alert.module.scss'
import clsx from 'clsx'

export type AlertProps = PropsWithChildren<{
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning'
  variant?: 'solid' | 'soft' | 'outlined'
  startAdornment?: ReactNode
  endAdornment?: ReactNode
}>

const Alert = ({ color = 'primary', variant = 'solid', children, startAdornment, endAdornment }: AlertProps) => {
  const className = clsx(classes.root, {
    [classes.primary]: color === 'primary',
    [classes.success]: color === 'success',
    [classes.warning]: color === 'warning',
    [classes.neutral]: color === 'neutral',
    [classes.danger]: color === 'danger',
    [classes.solid]: variant === 'solid',
    [classes.soft]: variant === 'soft',
    [classes.outlined]: variant === 'outlined',
  })
  return (
    <div className={className}>
      {startAdornment}
      <div className={classes.content}>{children}</div>
      {endAdornment}
    </div>
  )
}

export default Alert
